import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_51rdlopemv: FaireBrandEntity = {
  token: "b_51rdlopemv",
  type: "brand",
  name: "TCEC",
  avatarUrl:
    "https://cdn.faire.com/fastly/c36e0fe336e70c288c53711ae00d76bbaa9544eee58df04a4dc8e13744703c96.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/fb5c90535ecd918852ba87a988eb1437738e14a612bf3292d8a85927fab63c01.png",
  logoUrl:
    "https://cdn.faire.com/fastly/c36e0fe336e70c288c53711ae00d76bbaa9544eee58df04a4dc8e13744703c96.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/fb5c90535ecd918852ba87a988eb1437738e14a612bf3292d8a85927fab63c01.png",
  location: "Los Angeles, CA, USA",
  minimumOrderDollars: 100,
  rating: 4.8,
  reviewCount: 394,
  isTopShop: true,
  isInsider: true,
  description:
    "At TCEC, we design with the idea that Fashion should be modern and accessible. We love adding color to unexpected silhouettes that add a sense of newness & originality to the mundane. Our goal at TCEC is to provide playful fashion pieces that elevate every contemporary collection. We take pride in our elevated fabrics and intricate designs. We are here to inspire and promote self-love. Everyone deserves to feel confident and beautiful. We have made it our mission to bring this inspiration and promote elevated looks for an elevated lifestyle. The fashion industry is constantly evolving and it is our job to ensure that our pieces are continuously expanding to meet the consumers interests and needs. Fashion has the innate ability to enhance self-expression and we are here to help you find yours. Come see us, we can’t wait to meet you.",
  meta: {
    source: "api",
    importedAt: "2026-07-23T06:21:39.931Z",
    importedBy: "entity-db-cli",
  },
};
